<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[policySetup$]"></ef-loading-container>
<ef-pto-policy-presenter
    [companySettings]="companySettings$ | async"
    [policySetup]="policySetup$ | async"
    [policyAssignment]="policyAssignment$ | async"
    [groups]="groups$ | async"
    [userInfo]="userInfo$ | async"
    [accrualPeriods]="accrualPeriods$ | async"
    [process]="process$ | async"
    [accrualsFilterSelectItem]="accrualsFilterSelectItem"
    (SavePolicySetup)="onSavePolicySetup($event)"
    (DeletePolicySetup)="onDeletePolicySetup($event)"
    (SavePolicyAssignment)="onSavePolicyAssignment($event)"
    (UpdateCompanySetting)="onUpdateCompanySetting($event)"
    [isQBO]="isQBO$ | async"
>
</ef-pto-policy-presenter>
